import { SubmissionError } from 'redux-form/immutable';
import { saveContactInfo } from '../../../../Profile/services/API';

export default async function submit(vals, oldPassword) {
  let values = vals.toJS();
  const requiredMessage = 'Это поле обязательно для заполнения';
  const passwordDoesNotMatch = 'Пароли не совпадают';
  const requiredControlPassword = 'Введите пароль повторно';

  const errors = {};

  if (!values.newPassword1) {
    errors.newPassword1 = requiredMessage;
  }
  if (!values.newPassword2) {
    errors.newPassword2 = requiredControlPassword;
  }
  if (values.newPassword1 && values.newPassword2 && values.newPassword1 !== values.newPassword2) {
    errors.newPassword1 = passwordDoesNotMatch;
  }

  if (Object.keys(errors).length > 0) {
    throw new SubmissionError(errors);
  }

  const response = await saveContactInfo(Object.assign({}, values, { oldPassword }));
  return validateResponse(response);
}

async function validateResponse(response) {
  if (!response.isOk) {
    const error = response.error.response.data;
    const errorObject = error.newPassword2 || error.newPassword1 ? error : { _error: true };
    throw new SubmissionError(errorObject);
  }
}
